import { motion } from 'framer-motion';
import './tracking.css'; // 👈 Link to custom styles
import { FaCaretDown } from 'react-icons/fa';

export default function StopNode({ code, isCurrent, icon }) {
	return (
		<div className='stop-node'>
			{isCurrent && (
				<>
					<motion.div
						className='current-pulse'
						animate={{ scale: [1, 1.4, 1], opacity: [0.8, 0, 0] }}
						transition={{ repeat: Infinity, duration: 1.5, ease: 'easeInOut' }}
					/>
					<motion.div
						className='current-arrow'
						animate={{ y: [-17, -23, -17] }}
						transition={{ repeat: Infinity, duration: 2 }}
					>
						<FaCaretDown size={30} />
					</motion.div>
				</>
			)}
			<div className='circle-icon'>{code || ''}</div>
			<div className='code-label'></div>
		</div>
	);
}
